// removed by extract-text-webpack-plugin
module.exports = {"business-page-header":"business-page-header","business-contact-info":"business-contact-info","business-name":"business-name","portfolio":"portfolio","enabled":"enabled","btnViewPorfolio":"btnViewPorfolio","disabled":"disabled"};


//////////////////
// WEBPACK FOOTER
// ./components/business/business-page/styles/_business-page-header.scss
// module id = ./components/business/business-page/styles/_business-page-header.scss
// module chunks = 0